export default __webpack_public_path__ + "static/media/dash-hosp.81f9f41a.png";